<app-navbar></app-navbar>
<div class="container">
  <div class="row">
    <div class="col-12">
      <router-outlet></router-outlet>
    </div> 
  </div>
</div>
<app-footer></app-footer>
